import { html } from 'lit';
import { Minus } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-minus')
export class PdsIconMinus extends PdsIcon {
  @state()
  icon = Minus;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
